import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { PacienteConvenioDto, PacienteConvenioServiceProxy } from '@shared/service-proxies/service-proxies';
import { finalize } from 'rxjs/operators';
import { PagedListingComponentBase, PagedRequestDto } from '@shared/paged-listing-component-base';
import { ActivatedRoute } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CreateConvenioPacienteComponent } from './create-convenio-paciente/create-convenio-paciente.component';
import { EditConvenioPacienteComponent } from './edit-convenio-paciente/edit-convenio-paciente.component';

export class PagedPaceinteConvenioRequestDto extends PagedRequestDto {
  public pacienteId: string;
  public nomeConvenio: string;
}

@Component({
  selector: 'convenios-paciente',
  templateUrl: './convenios-paciente.component.html',
  styleUrls: ['./convenios-paciente.component.scss'],
})
export class ConveniosPacienteComponent extends PagedListingComponentBase<PacienteConvenioDto> implements OnInit {

  public pacienteConvenios: PacienteConvenioDto[] = [];
  public request: PagedPaceinteConvenioRequestDto = new PagedPaceinteConvenioRequestDto();
  @Input() pacienteId: string = null;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    inject: Injector,
    private readonly _pacienteConvenioServer: PacienteConvenioServiceProxy,
    private readonly route: ActivatedRoute,
    private _modalService: BsModalService,
  ) {
    super(inject)
  }

  ngOnInit(): void {
    if (this.pacienteId) {
      this.request.pacienteId = this.pacienteId;
      this.refresh();
    } else {
      this.route.params.subscribe(params => {
        const id = params['id'];
        this.request.pacienteId = id ?? this.appSession.pacienteId;
        this.refresh();
      });
    }
  }

  protected list(request: PagedPaceinteConvenioRequestDto, pageNumber: number, finishedCallback: Function): void {
    abp.ui.setBusy();
    request.pacienteId = this.request.pacienteId;
    request.nomeConvenio = this.request.nomeConvenio;
    this._pacienteConvenioServer.getAll(
      request.pacienteId,
      request.nomeConvenio,
      request.skipCount,
      request.maxResultCount
    ).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.pacienteConvenios = result.items;
      this.totalItems = result.totalCount;
      this.showPaging(result, pageNumber);
    });
  }

  protected delete(entity: PacienteConvenioDto): void {
    return;
  }

  protected create(): void {
    const createModal = this._modalService.show(
      CreateConvenioPacienteComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
        initialState: {
          pacienteId: this.request.pacienteId
        }
      }
    );

    createModal.content.onSave.subscribe(() => {
      abp.notify.success("Vínculo realizado com sucesso!");
      this.refresh();
    });
  }

  protected edit(entity: PacienteConvenioDto): void {
    const updateModal = this._modalService.show(
      EditConvenioPacienteComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
        initialState: {
          pacienteConvenio: entity.clone()
        }
      }
    );

    updateModal.content.onSave.subscribe(() => {
      abp.notify.success("Dados atualizado com sucesso!");
      this.refresh();
    });
  }

  protected activeOrDeActive(entity: PacienteConvenioDto): void {
    abp.ui.setBusy();
    this._pacienteConvenioServer.activeOrDeActive(entity.id).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe(() => {
      this.refresh();
    })
  }
}
